<template>
    <div class="list-form lang">
        <ul class="list-form__list">
            <li class="list-form__item" v-for="clinic in clinicList" :key="clinic">
                <router-link :to="`/ar/clinic?deptCd=${clinic.deptCd}`">
                    <span class="icon"><img :src="`/displayFile.do?name=${clinic.thumbAttach.savedName}`" alt="" v-if="clinic.thumbAttach && clinic.thumbAttach.savedName"></span>
                    <span>{{clinic.deptNmGlb}}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            clinicList: []
        }
    },
    mounted() {
        this.axios.get(this.api.department.list, {
            params: {
                hospId: this.$store.getters.getHost,
                deptType: 2,
                startIndex: 1,
                langCd: this.$store.getters.getLang,
                orderType: 'sortOrd'
            }
        }).then(res => {
            this.clinicList = res.data
        })
    },
}
</script>